import { deviceModel } from './components/admin/CreateUpdateLabDevice'

export const wardType = {
  id: 'Id',
  ward: 'Ward Or Room',
  floor: 'Floor Number',
  location: 'Operating Unit',
  noWards: 'No  Wards Found',
  maximumBeds: 'Maximum Beds',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'actions',
}
export const bedType = {
  id: 'Id',
  bedName: 'Bed',
  floor: 'Floor Number',
  roomName: 'Room',
  location: 'Operating Unit',
  bedCategory: 'Bed Category',
  noBeds: 'No Beds Found',
  seqNo: 'Seq.No',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const roomType = {
  id: 'Id',
  wardName: 'Ward Name',
  floor: 'Floor Number',
  roomNUmber: 'Room Number',
  roomName: 'Room Name',
  location: 'Operating Unit',
  noRooms: 'No Rooms Found',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const AdminIntent = {
  DeletepanelById: 'deletePanelById',
  InactiveTests: 'InactiveTests',
  DeletePackageById: 'DeletePackage',
  InactivePackage: 'inactivePackage',
  DeleteDoctor: 'deleteDoctor',
  getSpecialty: 'getSpecilities',
  DeleteSpecialty: 'deleteSpecailty',
  DeleteBed: 'deleteBed',
  ArchiveBed: 'toggleBedActive',
  DeleteRoom: 'deleteRoom',
  ArciveRoom: 'toggleRoomActive',
  DeleteWard: 'deleteWard',
  ArchiveWard: 'toggleWardActive',
  DeleteSample: 'deleteSample',
  ArchiveSample: 'toggleSampleStatus',
  DeleteLabTest: 'deleteLabTest',
  ArchiveLabTest: 'toggleLabTestStatus',
  DeleteLabDepartment: 'deleteLabDepartment',
  ArchiveLabDepartment: 'toggleDepartmentStatus',
  DeleteUnitType: 'deleteUnitType',
  ArchiveUnitType: 'toggleTestUnitTypeStatus',
  DeleteResultType: 'deleteTestResultType',
  ArchiveResultType: 'toggleTestResultType',
  DeleteMethodType: 'deleteTestMethod',
  ArchiveMethodType: 'toggleTestMethodTypeStatus',
  DeleteTestRange: 'deleteTestResultLimit',
  ArchiveTestRange: 'toggleParameterRangeStatus',
  DeletePathologist: 'deletePathologist',
  getPanelById: 'getPanelById',
  getTestTemplateById: 'getTestTemplateById',
  getRadiologyTestTemplatesById: 'getRadiologyTestTemplatesById',
  updateTestTemplate: 'updateTestTemplate',
  createTestTemplate: 'createTestTemplate',
  createRadiologyTestTemplate: 'createRadiologyTestTemplate',
  updateRadiologyTestTemplate: 'updateRadiologyTestTemplate',
}
export const referredTo = 'Referred To'
export const validatedOn = 'Validated on'
export const Labintent = {
  getReferredLabResults: 'getReferredLabResults',
  getPatientsByIdsApi: 'getPatientsByIdsApi',
  getOrderEventsByOrder: 'getOrderEventsByOrder',
  getBacklogFromView: 'getBacklogFromView',
}

export const create = 'CREATE'
export const update = 'UPDATE'
export const opdTableHeadings = {
  sl: 'Sl No',
  UHID: 'UHID',
  RegType: 'Reg.Type',
  Name: 'Name',
  MobileNo: 'Mobile No',
  Gender: 'Gender',
  Age: 'Age',
  OperatingUnit: 'Operating Unit',
  CreatedOn: 'Created On',
  UpdatedOn: 'Updated On',
  PatientDoc: 'Patient Doc',
  View: 'View',
}

export const opdvisistIntent = {
  visitErrorMsg: 'Error fetching visits:',
}

export const departmentTableHeadings = {
  id: 'Id',
  department: 'Department Name',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const labTestTableHeadings = {
  id: 'Id',
  parameterName: 'Parameter Name',
  department: 'Department',
  sample: 'Sample',
  test: 'Test',
  resultType: 'Result Type',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
  parameter_short_form: 'Parameter Short Form',
}

export const methodTableHeadings = {
  id: 'Id',
  method: 'Method',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const resultTypeTableHeadings = {
  id: 'Id',
  resultType: 'Result Type',
  description: 'Description',
  options: 'Options',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const sampleTableHeadings = {
  id: 'Id',
  sampleName: 'Sample Name',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const testRangeTableHeadings = {
  id: 'Id',
  parameterName: 'Parameter Name',
  testName: 'Test Name',
  gender: 'Gender',
  method: 'Method',
  unitType: 'Unit Type',
  ageRange: 'Age Range',
  valueRange: 'Value Range',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const unitTypeTableHeadings = {
  id: 'Id',
  unit: 'Unit',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const menuValues = {
  Doctor: 'doctor',
  Location: 'location',
  Bed: 'beds',
  Room: 'rooms',
  Ward: 'ward',
  LabDepartment: 'department',
  Method: 'method',
  Packages: 'packages',
  Parameter: 'labTest',
  ParameterRange: 'testRange',
  Pathologist: 'pathologist',
  ResultType: 'resultType',
  Sample: 'sample',
  Panel: 'panel',
  UnitType: 'unitType',
  Sequence: 'sequence',
  Partner: 'partner',
  parameterSequence: 'Parameter Sequence',
  reportTemplate: 'reportTemplate',
  radiologyReportTemplates: 'radiologyReportTemplates',
  none: 'none',
}
export const paragraphText = '<p><br></p>'
export const createLabOrderRoute = 'search/createorder/:id'
export const orderStatus = {
  ordered: 'ORDERED',
  orderedModified: 'ORDER_MODIFIED',
  collected: 'COLLECTED',
  collectionRejected: 'COLLECTION_REJECTED',
  rejected: 'REJECTED',
  collectionApproved: 'COLLECTION_APPROVED',
  entered: 'ENTERED',
  enteredReferred: 'ENTERED_REFERRED',
  submitted: 'SUBMITTED',
  approved: 'APPROVED',
  collection: 'collection',
  testing: 'testing',
  validation: 'validation',
  Dispatch: 'Dispatch',
}
export const labErrorMessages = {
  fecthPatient: 'unable to fetch patient',
  noPanels: 'No panels found for this order.',
  invoiceError: 'An error occurred while generating the invoice.',
}
export const allLabTab = {
  all: 'all',
  collection: 'collection',
  LOC_ALLOCATED: 'LOC_ALLOCATED',
  dispatch: 'dispatch',
  testing: 'testing',
  validation: 'validation',
  enter: 'enter',
  validate: 'validate',
}
export const patientConstants = {
  mobile: 'mobile',
  patientIdentifier: 'patient-identifier',
}
export const invoicePdf = {
  CBP: 'Complete Blood Picture (CBP) Blood',
}
export const SlotDetails = 'Slot Details'
export const TimeSlot = ' Time Slot : '
export const DateValue = 'Date :'
export const tagElements = {
  tag: 'tag',
  headingOne: 'h1',
  headingTwo: 'h2',
  paragraph: 'p',
  listItems: 'li',
  unlistItems: 'ul',
  strong: 'strong',
  em: 'em',
}
export const switchLoc = 'Switched to location'
export const labTabs = [
  'collection',
  'testing',
  'validation',
  'dispatch',
  'LOC_ALLOCATED',
]
export const exceptDisptach = [
  'collection',
  'testing',
  'validation',
  'LOC_ALLOCATED',
]
export const BackLogButton = 'Backlog Orders'
export const validate = 'validate'
export const enter = 'enter'
export const validateText = 'validate'
export const enterResults = 'Enter Results'
export const validationPending = 'Validation Pending'
export const viewResults = 'View results'
export const current = 'current'
export const backlog = 'backlog'
export const getLabResultByLabOrderIdIntent = 'getLabResultByLabOrderId'
export const systemResultEnteredBy = 'LIS'
export const LmsTestTab = 'testing'
export const enterMode = 'enter'
export const orderCollectedState = 'COLLECTED'
export const orderSubmittedState = 'SUBMITTED'
export const orderStatusRejected = 'REJECTED'
export const labDeviceTableColumns = [
  {
    name: 'name',
    label: 'Device Name',
    mandatory: true,
  },
  {
    name: 'facility',
    label: 'Operating Unit',
    dropDown: [],
    mandatory: true,
  },
  {
    name: 'location',
    label: 'Location',
    mandatory: false,
  },
  {
    name: 'model_id',
    label: 'Model',
    mandatory: true,
    dropDown: [],
  },
  {
    name: 'device_ip',
    label: 'Device IP',
    mandatory: false,
  },
  {
    name: 'internal_port',
    label: 'Internal Port',
    mandatory: false,
  },
  {
    name: 'external_port',
    label: 'External Port',
    mandatory: false,
  },
]

export const labDeviceModelColumns = [
  {
    name: 'name',
    label: 'Model Name',
    mandatory: true,
  },
  {
    name: 'equipment_name',
    label: 'Equipment Name',
    mandatory: true,
  },
  {
    name: 'department',
    label: 'Department',
    mandatory: false,
    dropDown: [],
  },
  {
    name: 'device_type',
    label: 'Device Type',
    dropDown: ['ANALYZER', 'VENTILATOR'],
    mandatory: true,
  },
  {
    name: 'default_connection_type',
    label: 'Mode',
    dropDown: ['listen', 'connect'],
    mandatory: true,
  },
  {
    name: 'protocol',
    label: 'Protocol',
    dropDown: ['HL7 MLLP', 'CIE', 'MEDIBUS', 'MEDIBUS.X', 'DAICOM'],
    mandatory: true,
  },
  {
    name: 'vendor',
    label: 'Vendor',
    mandatory: true,
  },
  {
    name: 'mapping_key',
    label: 'Mapping Key',
    mandatory: true,
    dropDown: ['CHANNEL_ID', 'TEST_CODE'],
  },
]

export const ParameterMappingsColumns = [
  {
    name: 'channel_id',
    label: 'Channel Id',
    mandatory: true,
  },
  {
    name: 'test_code',
    label: 'Device Parameter Code',
    mandatory: true,
  },
  {
    name: 'test_type',
    label: 'Test Type',
    mandatory: true,
  },
  {
    name: 'test_name',
    label: 'Device Parameter Name',
    mandatory: true,
  },
  {
    name: 'thop_name',
    label: 'Thop Parameter Name',
    mandatory: true,
    dropDown: [],
  },
  {
    name: 'thop_parameter_code',
    label: 'Thop Parameter Code',
    mandatory: true,
  },
  {
    name: 'result_type',
    label: 'Result Type',
    mandatory: true,
  },
  {
    name: 'decimal_precision',
    label: 'Decimal Precision',
    mandatory: true,
  },
  {
    name: 'scaling_factor',
    label: 'Scaling Factor',
    mandatory: true,
  },
]

export const lmsFormNoneMode = 'none'
export const lmsFormCreateMode = 'create'
export const lmsFormEditMode = 'edit'
export const labDeviceEnabledColumn = 'enabled'
export const labDeviceItem = 'labDevice'
export const labDeviceModelItem = 'labDeviceModel'
export const parameterMappingItem = 'parameterMapping'
export const labDeviceModelListenMode = 'listen'
export const labDeviceModelConnectMode = 'connect'
export const labdeviceModelColumn = 'model_id'
export const labDeviceOperatingUnitColumn = 'facility'
export const fillAllMandatoryFieldsWarning = 'Please fill all mandatory fields'
export const labDeviceModelDepartmentColumn = 'department'

export const connnectColumns = ['device_ip', 'external_port']
export const listenColumns = ['internal_port']
export const modelMandatoryColumns = [
  'name',
  'equipment_name',
  'device_type',
  'default_connection_type',
  'protocol',
  'vendor',
  'department',
  'mapping_key',
]
export const deviceMandatoryColumns = ['model_id', 'name', 'facility']
export const parameterMandatoryColumns = [
  'channel_id',
  'test_code',
  'test_type',
  'test_name',
  'thop_parameter_code',
  'thop_name',
  'result_type',
  'decimal_precision',
  'scaling_factor',
]
export const labDeviceRelatedItems = [
  'parameterMapping',
  'labDevice',
  'labDeviceModel',
]

export const FILE_UPLOAD_FAIL = 'Failed to upload file'
export const ID = 'id'
export const PARAMETER_DELETE_SUCCESS = 'Parameter deleted successfully'
export const EDIT = 'Edit'
export const ADD = 'Add'
export const NAVIGATE_PARAMETER_MAPPING = '/labDeviceModel/Parameters/'

export const getModel = (
  models: deviceModel[],
  values: Record<string, any>
) => {
  return models?.filter((model: any) => model?.name === values?.model_id)?.[0]
}

export const parameterMapping = 'Parameter Mapping'
export const labDeviceModels = 'Lab Device Models'
export const OF = 'of'
export const MODEL = 'Model'
export const printOptions = [
  { label: 'Medunited', value: 'medunited' },
  { label: 'Lab IQ', value: 'labIq' },
  { label: 'KIMS', value: 'kims' },
]
export const kimsString = 'kims'
export const labIqString = 'labIq'

export const collectOrderHeading = {
  SlNo: 'Sl No',
  LRNumber: 'LR.Number',
  UHID: 'UHID',
  Name: 'Name',
  MobileNo: 'Mobile No.',
  OP: 'Operating Unit',
  Service: 'Service',
  OrderedOn: 'Ordered On',
  Tests: 'Tests',
  Actions: 'Actions',
}
export const locErrorMsg = {
  AsignedLoc: 'Lab order updated successfully',
  FailedAsignedLoc: 'Failed to update lab order PU:',
}
export const DashboardTabs = {
  COLLECTED: 'COLLECTED',
}
export const LAB_ANALYZER_TABLE_HEADING = 'Lab Analyzers'
export const SUBMIT = 'Submit'
export const loadingMessage = 'Please Wait loading data...'
export const thopParameterNameField = 'thop_name'
export const thopParameterCodeField = 'thop_parameter_code'
export const resultTypeField = 'result_type'
export const parameterIdField = 'parameter_id'
export const labDeviceSearchItems = [
  'Device Name',
  'Model Name',
  'Vendor',
  'Operating Unit',
  'Location',
]

export const CREATE = 'Create'
export const testsLowercase = 'tests'
export const deviceNameField = 'Device Name'
export const deviceModelNameField = 'Model Name'
export const deviceVendorField = 'Vendor'
export const deviceOperatingUnitField = 'Operating Unit'
export const deviceLocationField = 'Location'
export const deviceNameKey = 'device_name'
export const deviceModelNameKey = 'model_name'
export const deviceVendorKey = 'vendor'
export const deviceOperatingUnitKey = 'facility'
export const deviceLocationKey = 'location'
export const printingMessage = 'Please Wait While Printing....'
export const SampleCollection = 'SampleCollection'
export const SampleAcknowledge = 'SampleAcknowledge'
export const invoice = 'invoice'
export const saleOrder = 'sale_order'
export const successCancel = 'Successfully cancelled.'
export const cancelFailed = 'Cancellation failed.'
export const errorFailed = 'Something went wrong.'
